module.exports = __webpack_public_path__ + "static/img/file_markdown.98f16920.png";